var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", { attrs: { cx: "10", cy: "10", r: "10", fill: _vm.color } }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M13.4285 7.92859H6.42078L8.5422 5.27682C8.81327 4.93739 8.75827 4.44318 8.41963 4.17211C8.08099 3.90182 7.58599 3.95525 7.31492 4.29468L4.17207 8.22324C3.94264 8.51081 3.94264 8.9178 4.17207 9.20538L7.31492 13.1339C7.47049 13.328 7.69835 13.4286 7.92856 13.4286C8.10142 13.4286 8.27427 13.372 8.41963 13.2565C8.75827 12.9854 8.81327 12.4912 8.5422 12.1518L6.42078 9.50002H13.4285C13.8615 9.50002 14.2143 9.8528 14.2143 10.2857V14.2143C14.2143 14.648 14.5663 15 15 15C15.4337 15 15.7857 14.648 15.7857 14.2143V10.2857C15.7857 8.98616 14.7281 7.92859 13.4285 7.92859Z",
          fill: _vm.circleColor
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }